
export default function Reviews() {
  const reviews = [
    {
      name: 'Mariana Santos',
      date: '3 meses atrás',
      rating: 5,
      text: 'Escola excepcional! Minha filha desenvolveu muito o inglês e está sempre animada para ir às aulas. O carinho dos professores é notável.',
      avatar: 'https://public.readdy.ai/ai/img_res/2d23b0440e9292253f527e65fa335bed.jpg'
    },
    {
      name: 'Carlos Eduardo',
      date: '6 meses atrás',
      rating: 5,
      text: 'Metodologia incrível! Nosso filho aprendeu inglês de forma natural e divertida. Recomendo para todas as famílias de Paulínia.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20Brazilian%20father%20with%20short%20dark%20hair%2C%20wearing%20business%20casual%20shirt%2C%20confident%20and%20approachable%20expression%2C%20natural%20lighting%2C%20clean%20white%20background&width=64&height=64&seq=2&orientation=squarish'
    },
    {
      name: 'Ana Paula Oliveira',
      date: '1 ano atrás',
      rating: 5,
      text: 'A melhor decisão que tomamos! A estrutura é maravilhosa e o ensino bilíngue realmente funciona. Nossos filhos adoram a escola!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20Brazilian%20woman%20with%20curly%20hair%2C%20wearing%20colorful%20blouse%2C%20joyful%20and%20warm%20expression%2C%20natural%20lighting%2C%20clean%20white%20background&width=64&height=64&seq=3&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-red-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
            O que dizem sobre nós
          </h2>
          <div className="flex items-center justify-center gap-2 text-yellow-400 text-2xl mb-2">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
          </div>
          <p className="text-gray-600">Avaliações verificadas do Google</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white to-red-50 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-red-100"
            >
              <div className="flex items-center gap-4 mb-4">
                <img 
                  src={review.avatar}
                  alt={review.name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-red-200"
                />
                <div>
                  <h3 className="font-bold text-gray-900">{review.name}</h3>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed">
                {review.text}
              </p>

              <div className="mt-4 flex items-center gap-2 text-sm text-gray-500">
                <img 
                  src="https://cdn.trustindex.io/assets/platform/Google/icon.svg"
                  alt="Google"
                  className="w-5 h-5"
                />
                <span>Avaliação verificada do Google</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
